import UpdateMarinaCoverNoteBill from "../Update";

const ViewMarinaCoverNoteBill = (props) => {
  return <UpdateMarinaCoverNoteBill {...props} viewMode={true} />;
};

export default ViewMarinaCoverNoteBill;
